import React from "react"
import {findDOMNode} from "react-dom"

import SelectMultiGenericPopoverOption from "./option/option"
import SelectMultiGenericNew from "../select-multi-generic-new"

type Props = {
    parent                  : SelectMultiGenericNew

    options                 : Option[]

    searchString            : string | null

    allValuesOptionLabel    : string
    allValuesOption         : boolean   // is all values option available
    keyboardNavigation      : boolean

    popoverOptionComponent? : func

    onUpdateScroll          : func
}

type State = {
    currentCursorKey: number | null
}

export default class SelectMultiGenericPopoverOptionsSelector extends React.Component<Props, State> {

    private optionRef: any = {} // references for options for keyboard navigation

    static defaultProps = {
        keyboardNavigation  : true
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            currentCursorKey: null
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
        const node = this.optionRef[this.state.currentCursorKey as  keyof {}] ?
            findDOMNode(this.optionRef[this.state.currentCursorKey as  keyof {}])
            :
            null

        // scroll for cursor to be visible
        if (node) {
            this.props.onUpdateScroll(node)
        }
    }

    _getOptions = () => {
        let options = this.props.options.slice()

        // filter options by search string
        let searchString = this.props.searchString
        if (searchString) {
            searchString = searchString.toLowerCase()
            options = _(options)
                .filter(option => !!option.label && option.label.toLowerCase().includes(searchString!))
                .value()
        }

        // add all values if necessary
        if (this.props.allValuesOption) {
            options.unshift({
                isAllValuesOption   : true,
                label               : this.props.allValuesOptionLabel
            })
        }

        return options;
    }

    onClickOption = (option: Option) => {
        this.props.parent.onOptionClick(option)
    }

    onChangeCursorOption = (newValue: number) => {
        this.setState({
            currentCursorKey: newValue
        })
    }

    onPopoverKeyDown = (event: React.KeyboardEvent) => {
        if (!this.props.keyboardNavigation) return

        const options = this._getOptions()

        let newValue

        switch(event.key) {
            case 'Escape':
                this.props.parent.hidePopover()
                break

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey - 1;
                    if (newValue < 0) newValue = 0
                }

                this.onChangeCursorOption(newValue)
                break

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > options.length - 1) newValue = options.length - 1
                }

                this.onChangeCursorOption(newValue)
                break

            case 'Enter':
                if (this.state.currentCursorKey !== null) {
                    const curOption = options[this.state.currentCursorKey]
                    if (curOption) this.onClickOption(curOption)
                }
                break
        }
    }

    render() {
        const options = this._getOptions()
        const highlightedOption = options[this.state.currentCursorKey as keyof {}]
        const selectedOptions = this.props.parent.state.currentOptions ? this.props.parent.state.currentOptions : []

        const PopoverOption = this.props.popoverOptionComponent || SelectMultiGenericPopoverOption

        return (
            <>
                {_.map(options, (option, key) => {
                    if (option.excludeFromSelectable) return false

                    return (
                        <PopoverOption ref              = {(ref: any)=>this.optionRef[key] = ref}
                                       key              = {option.isAllValuesOption ? 'all_values' : option.value}
                                       option           = {option}
                                       isHighlighted    = {highlightedOption && highlightedOption.value === option.value}
                                       isSelected       = {selectedOptions.includes(option.value)}
                                       onClick          = {()=>this.onClickOption(option)}/>
                    )
                })}
            </>
        )
    }
}